import React from 'react';
import classnames from 'classnames';
import './MapLayersPanelStyles.scss';
import capacity from './capacity';
import marketplace from './marketplace';
import onRamps from './onRamps';
import layers from './layers';
import ems from './ems';

const children = {
  capacity,
  marketplace,
  onRamps,
  layers,
  ems,
};

const MapLayersPanel = ({ selectedLayer, setSelectedLayer, ...rest }) => {
  const Component = children[selectedLayer.value];
  return (
    <div className={classnames('layers-panel', { isLayersPanelCollapsed: !!selectedLayer })}>
      <div className="header">
        <span>{selectedLayer.label}</span>
        <button className="close-panel" onClick={() => setSelectedLayer(null)}>
          <svg height="12" width="12">
            <path d="M0 0 L12 12 M12 0 L0 12" width="12" height="12" />
          </svg>
        </button>
      </div>
      {Component ? <Component {...rest} /> : null}
    </div>
  );
};

export default MapLayersPanel;
